export const setCurrentSelections = (payload) => {
  return { type: "SET_CURRENT_SELECTIONS", payload };
};

export const updateSelection = (payload) => {
  return { type: "UPDATE_SELECTION", payload };
};
